/**
 * Session Storage Service
 * Manages persistence of reconnectSecret and chatId in sessionStorage.
 * The sessionKey is NEVER persisted — it remains in-memory only.
 */

const KEYS = {
  reconnectSecret: 'mariana.reconnectSecret',
  chatId: 'mariana.chatId',
} as const;

// --- reconnectSecret ---

export function getReconnectSecret(): string | null {
  try {
    return sessionStorage.getItem(KEYS.reconnectSecret);
  } catch {
    return null;
  }
}

export function setReconnectSecret(reconnectSecret: string): void {
  try {
    sessionStorage.setItem(KEYS.reconnectSecret, reconnectSecret);
  } catch {
    // Silently fail — worst case we lose reconnect capability
  }
}

export function clearReconnectSecret(): void {
  try {
    sessionStorage.removeItem(KEYS.reconnectSecret);
  } catch {
    // noop
  }
}

// --- chatId ---

export function getChatId(): string | null {
  try {
    return sessionStorage.getItem(KEYS.chatId);
  } catch {
    return null;
  }
}

export function setChatId(chatId: string): void {
  try {
    sessionStorage.setItem(KEYS.chatId, chatId);
  } catch {
    // Silently fail — worst case we lose reconnect capability
  }
}

export function clearChatId(): void {
  try {
    sessionStorage.removeItem(KEYS.chatId);
  } catch {
    // noop
  }
}

// --- Clear all Mariana session data ---

export function clearAllSessionData(): void {
  clearReconnectSecret();
  clearChatId();
}